import React from 'react';

const TechLogo = () => {
  // Array of logo URLs (SVGs from Simple Icons)
  const logoItems = [
    '../images/tech_logo/tech_logo1.png',
    '../images/tech_logo/tech_logo2.svg',
     '../images/tech_logo/tech_logo3.png',
    '../images/tech_logo/tech_logo4.svg',
     '../images/tech_logo/tech_logo5.png',
    '../images/tech_logo/tech_logo6.svg',
     '../images/tech_logo/tech_logo7.png',
    '../images/tech_logo/tech_logo8.svg',
     '../images/tech_logo/tech_logo9.png',
    '../images/tech_logo/tech_logo10.svg',
     '../images/tech_logo/tech_logo11.png',
    '../images/tech_logo/tech_logo12.svg',
     '../images/tech_logo/tech_logo13.png',
     '../images/tech_logo/tech_logo14.png',
     '../images/tech_logo/tech_logo15.png',
     '../images/tech_logo/tech_logo16.png',

  
  ];

  // Duplicate the items for smooth scrolling (to create seamless loop)
  const repeatedItems = [...logoItems, ...logoItems];

  return (
    <>
    
    <div className="relative ticker-wrapper border mt-10 mb-5 bg-[#fff] overflow-hidden">
      <div className="py-6 ticker-track animate-texh-logo whitespace-nowrap">
        {repeatedItems.map((logo, index) => (
            <div
            key={index}
            className="ticker-item flex items-center justify-center mx-6 min-w-[150px]"
          >
            <img src={logo} alt={`Tech logo ${index}`} className="h-12" />
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default TechLogo;
